module.exports = __webpack_public_path__ + "img/compare.cd7d8a31.svg";